<p-drawer [visible]="showPosBillingSidebar()" [showCloseIcon]="false" position="right" [blockScroll]="true" styleClass="w-full payment-sidebar no-header" [dismissible]="false" [closeOnEscape]="!isPaymentFlowBlockingUi" (onHide)="onBillingSidebarHide()">
    <ng-template #header>
        <!-- Header -->
        <div class="border-bottom-1 border-200 bg-surface-50 relative flex align-items-center justify-content-between p-2 pb-2 w-full">
            <div class="flex align-items-center gap-3">
                <div class="flex align-items-center gap-2">
                    <i class="fa fa-file-invoice text-primary text-lg"></i>
                    <span class="text-sm font-semibold text-900">
                        {{'POS.MEMBERSHIP_ADDON.BILL_SUMMARY' | translate}}
                    </span>
                </div>
                
                <!-- Client Details in Header -->
                @if (posDetails; as planSummary) {
                  <div class="flex align-items-center gap-2 border-left-1 border-200 pl-3">
                      <div class="h-1-5rem w-1-5rem">
                          @if (planSummary.client.client_image) {
                            <p-avatar [image]="planSummary.client.client_image" shape="circle" size="small" />
                          } @else {
                            <p-avatar [label]="planSummary.client.client_name | titlecase | shortName" shape="circle" size="small" />
                          }
                      </div>
                    <div class="flex flex-column">
                        <div class="flex align-items-center gap-2">
                            <a
                                href="../client/profile/{{ planSummary.client.client_id }}"
                                class="text-primary text-xs font-semibold border-bottom-1 border-white hover:border-primary transition-colors"
                                [attr.aria-label]="'client-profile-link'"
                                [attr.data-testid]="'client-profile-link'"
                            >
                                {{ planSummary.client.client_name }}
                            </a>
                            <div [innerHTML]="clientStatus( planSummary.client)"></div>
                        </div>
                        <div class="text-600 text-xxs">
                            ID: {{planSummary.client.client_id}}
                            @if (billingNameFormControl.value) {
                              <span class="ml-1">
                                  • {{billingNameFormControl.value}}
                              </span>
                            }
                        </div>
                    </div>
                  </div>
                }
            </div>
            
            <div class="flex align-items-center gap-2">
                <!-- Client Actions Menu -->
                @if (posDetails; as planSummary) {
                  <button
                      pButton
                      pRipple
                      type="button"
                      icon="fa fa-ellipsis-v"
                      class="p-button-text p-button-sm text-600 hover:text-900"
                      (click)="action.toggle($event)"
                      [attr.aria-label]="'client-actions-menu-button'"
                      [attr.data-testid]="'client-actions-menu-button'"
                  ></button>
                }
                <p-popover #action styleClass="overflow-hidden text-sm w-10rem">
                    <ng-template #content>
                        <ul class="list-none m-0 p-1">
                            <li class="cursor-pointer hover:bg-surface-100 p-2 border-round flex align-items-center text-xs text-600" (click)="changeBillingName=true">
                                <i class="fa fa-user-edit text-xs mr-2"></i>{{'POS.MEMBERSHIP_ADDON.EDIT_BILLING_NAME' | translate}}
                            </li>
                        </ul>
                    </ng-template>
                </p-popover>
                
                <!-- Close Button -->
                <button
                    (click)="onBillingSidebarHide()"
                    class="p-button-text p-button-sm text-600 hover:text-900"
                    pButton
                    pRipple
                    type="button"
                    icon="fa fa-times"
                    [attr.aria-label]="'close-pos-billing-sidebar'"
                    [attr.data-testid]="'close-pos-billing-sidebar'"
                ></button>
            </div>
        </div>
        <!-- Header -->
    </ng-template>
    <ng-template #content>
        <form [formGroup]="fg" class="p-sidebar-content__wrapper flex flex-column justify-content-between">
            <!-- Content -->
            <div>
                @if (!hasbillingRights) {
                  <div class="md:pt-3 pt-2 md:px-4 px-3 pb-8">
                    <div class="flex justify-content-between">
                        <h1 class="text-base md:text-lg text-900 flex align-items-center mb-0 line-height-1">
                            {{ 'POS.MEMBERSHIP_ADDON.POS-CHARGES' | translate }}
                            <i
                                class="fa fa-question-circle font-light text-xl text-600 cursor-pointer ml-2"
                                pTooltip="{{ 'POS.MEMBERSHIP_ADDON.POS-CHARGES' | translate }}"
                                tooltipStyleClass="text-xs"
                                [attr.aria-label]="'pos-charges-info'"
                                [attr.data-testid]="'pos-charges-info'"
                            ></i>
                        </h1>

                        <div>
                            <p-button label="{{ 'POS.MEMBERSHIP_ADDON.REQUEST_ACCESS' | translate }}"
                                icon="fa fa-lock"
                                styleClass="text-sm hidden md:flex"
                                (click)="RequestAccess()"
                                [attr.aria-label]="'request-access-button'"
                                [attr.data-testid]="'request-access-button'"
                             />
                            <p-button icon="fa fa-lock" styleClass="text-sm md:hidden" [attr.aria-label]="'request-access-button-mobile'" [attr.data-testid]="'request-access-button-mobile'" />
                        </div>
                    </div>

                    <hr class="border-300 border-top-1 border-bottom-none border-left-none border-right-none my-3" />

                    <!-- Card -->
                    <div class="surface-0 shadow-2 pb-6">
                        <p-message severity="error" icon="fa fa-times" aria-label="access-denied-message">
                            {{ 'POS.MEMBERSHIP_ADDON.YOU_DONT_HAVEACCESS' | translate }}
                        </p-message>

                        <div class="text-center mt-6">
                            <img src="/assets/img/no-data-img.svg" alt="Request Access" />
                            <br />

                            <p-button label="{{ 'POS.MEMBERSHIP_ADDON.REQUEST_ACCESS' | translate }}" icon="fa fa-lock" styleClass="text-sm mt-5" (click)="RequestAccess()" />
                        </div>
                    </div>
                    <!-- Card -->
                  </div>
                }

                @if (hasbillingRights) {
                  <div>

                    @if (showCartSummaryCard) {
                    <div class="border-1 border-200 border-round p-2  my-1">
                        @if (chargeMasterList$ | async; as obj) {
                          @if (disableChargeMasterDropdown) {
                            <p-select
                                [options]="chargeMasterList$ | async"
                                formControlName="ddlplanSubscriptionList"
                                optionLabel="name_primary_language"
                                filterBy="name_primary_language"
                                [filter]="true"
                                styleClass="w-full text-sm"
                                placeholder="{{'POS.MEMBERSHIP_ADDON.SELECT_CHARGE' | translate}}"
                                [attr.aria-label]="'select-product-dropdown'"
                                [attr.data-testid]="'select-product-dropdown'"
                            >
                                <ng-template pTemplate="selectedItem">
                                    @if (planList.value) {
                                      <div class="flex align-items-center text-xs md:text-sm">
                                          @if (planList.value.charge_category_name_primary_language) {
                                            <span class="bg-orange-50 uppercase px-2 py-1 border-round text-orange-700 border-1 border-orange-200 text-xxs">
                                                {{ authService.getLocalizedFieldData(planList.value.charge_category_name_primary_language, planList.value.charge_category_name_secondary_language) | async }}
                                            </span>
                                          }
                                          <span class="mx-2">
                                              {{authService.getLocalizedFieldData(planList.value.name_primary_language,planList.value.name_secondary_language) | async}}
                                          </span>
                                          <strong>
                                              {{getChargeMasterAmount(planList.value) | currencyformat}}
                                          </strong>
                                      </div>
                                    }
                                </ng-template>
                                <ng-template let-charge pTemplate="item">
                                    <div class="flex align-items-center text-xxs md:text-sm" [attr.data-testid]="'charge-item-'+charge.name_primary_language" [attr.aria-label]="'charge-item-'+charge.name_primary_language">
                                        @if (charge.charge_category_name_primary_language) {
                                          <span class="bg-orange-50 uppercase px-2 py-1 border-round text-orange-700 border-1 border-orange-200 text-xxs">
                                              {{ authService.getLocalizedFieldData(charge.charge_category_name_primary_language, charge.charge_category_name_secondary_language) | async }}
                                          </span>
                                        }
                                        <span
                                            class="mx-2 w-8rem overflow-hidden white-space-nowrap text-overflow-ellipsis"
                                            pTooltip="{{authService.getLocalizedFieldData(charge.name_primary_language,charge.name_secondary_language) | async}}"
                                            tooltipStyleClass="text-xs"
                                        >
                                            {{authService.getLocalizedFieldData(charge.name_primary_language,charge.name_secondary_language) | async}}
                                        </span>
                                        <strong>
                                            {{getChargeMasterAmount(charge) | currencyformat}}
                                        </strong>
                                    </div>
                                </ng-template>
                            </p-select>
                          }
                        } @else {
                          <div class="skeleton">
                              <p-skeleton styleClass="mb-2" />
                          </div>
                        }

                        <!-- Products Section (cart summary; breakup products shown in Bill Details below) -->
                        @if (posDetails && posDetails.subscriptionProductsAndCharges && posDetails.subscriptionProductsAndCharges?.products?.length > 0 && !((planBreakUpCalculationResponse$ | async)?.plan_breakup_calculation?.charging_today?.products?.length)) {
                            <!-- Products Header -->
                            <div class="flex align-items-center gap-2 mt-2 mb-1 px-2 py-1 bg-blue-50 border-round">
                                <i class="fa fa-cube text-blue-600 text-xs"></i>
                                <span class="text-xs font-medium text-blue-900">
                                    {{ 'RETAIL_PRODUCTS.PRODUCTS' | translate }} ({{ posDetails.subscriptionProductsAndCharges?.products?.length }})
                                </span>
                            </div>

                            <!-- Products List -->
                            <div class="products-container">
                                @for (product of posDetails.subscriptionProductsAndCharges?.products; track trackByProductId($index, product)) {
                                  <div class="flex justify-content-between align-items-center p-2 border-1 border-200 border-round mb-1 hover:bg-surface-50 transition-colors">
                                    <!-- Product Info -->
                                    <div class="flex align-items-center gap-2 flex-1">
                                        <div class="w-1-5rem h-1-5rem bg-blue-100 border-round flex align-items-center justify-content-center flex-shrink-0">
                                            <i class="fa fa-box text-blue-600 text-xs"></i>
                                        </div>
                                        <div class="flex-1">
                                            <div class="text-sm font-medium text-900 mb-1 line-height-2">
                                                {{ product.product_sku?.sku_name_primary_language || product.sku_name_primary_language }}
                                            </div>
                                            <div class="flex align-items-center gap-2">
                                                <span class="text-xs px-1 py-0 bg-surface-100 border-round text-600">
                                                    {{ product.product_sku?.sku_code || 'N/A' }}
                                                </span>
                                                <span class="text-xs text-blue-800 font-medium">
                                                    Qty: {{ product.quantity }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Product Price -->
                                    <div class="text-right flex-shrink-0">
                                        <div class="text-sm font-bold text-900">
                                            {{ (product.product_sku?.unit_price_minor * product.quantity) | currencyformat }}
                                        </div>
                                        <div class="text-xs text-600">
                                            {{ product.product_sku?.unit_price_minor | currencyformat }} × {{ product.quantity }}
                                        </div>
                                    </div>
                                  </div>
                                }
                            </div>
                        }

                        <!-- Charges Section (picker mode only; breakup shown in Bill Details when charge is pre-selected) -->
                        @if ((chargeMasterList$ | async)?.length > 0 && disableChargeMasterDropdown) {
                            <!-- Charges Header -->
                            @if (!disableChargeMasterDropdown) {
                            <div class="flex align-items-center gap-2 mt-2 mb-1 px-2 py-1 bg-orange-50 border-round">
                                <i class="fa fa-receipt text-orange-600 text-xs"></i>
                                <span class="text-xs font-medium text-orange-900">
                                    {{ 'RETAIL_PRODUCTS.CHARGES' | translate }}
                                </span>
                            </div>
                            }

                            <!-- Charges List -->
                            <div class="charges-container">
                                @for (charge of posDetails.subscriptionProductsAndCharges?.charges; track charge.charge_id) {
                                  <div class="flex justify-content-between align-items-center p-2 border-1 border-200 border-round mb-1 hover:bg-surface-50 transition-colors">
                                      <!-- Charge Info -->
                                      @if (getChargeDetails(charge.charge_id); as obj) {
                                        <div class="flex align-items-center gap-2 flex-1">
                                        <div class="w-1-5rem h-1-5rem bg-orange-100 border-round flex align-items-center justify-content-center flex-shrink-0">
                                            <i class="fa fa-tag text-orange-600 text-xs"></i>
                                        </div>
                                        <div class="flex-1">
                                            <div class="text-sm font-medium text-900 mb-1 line-height-2">
                                                {{ authService.getLocalizedFieldData(obj.name_primary_language,obj.name_secondary_language) | async}}
                                            </div>
                                            @if (authService.getLocalizedFieldData(obj.description_primary_language,obj.description_secondary_language) | async) {
                                              <div class="text-xs text-600">
                                                  {{ authService.getLocalizedFieldData(obj.description_primary_language,obj.description_secondary_language) | async}}
                                              </div>
                                            }
                                            <span class="text-xs text-orange-800 font-medium">
                                                One-time charge
                                            </span>
                                        </div>
                                        </div>
                                      }

                                      <!-- Charge Price -->
                                      @if (getChargeAmount(charge.charge_id); as amount) {
                                        <div class="text-right flex-shrink-0">
                                        <div class="text-sm font-bold text-900">
                                            {{ amount | currencyformat }}
                                        </div>
                                        </div>
                                      }
                                  </div>
                                }
                            </div>
                        } @else {
                          @if (subscriptionPlanId > 0) {
                            <div class="skeleton p-2">
                                <p-skeleton styleClass="mb-1" height="1rem" />
                                <p-skeleton width="8rem" styleClass="mb-1" height="0.8rem" />
                                <p-skeleton width="4rem" styleClass="mb-1" height="0.8rem" />
                                <p-skeleton height="1.5rem" styleClass="mb-1" />
                                <p-skeleton width="8rem" height="2rem" />
                            </div>
                          }
                        }

                        <!-- Separator -->
                        <hr class="border-200 border-top-1 border-bottom-none border-left-none border-right-none my-2" />
                    </div>
                    }

                    <!-- Info Card -->

                    <!-- Mid Part -->
                    <div class="bg-surface-50 p-2 border-top-1 border-200 mt-1">
                        <!-- Bill Details -->
                        <div class="mt-1">
                            <div class="flex align-items-center gap-2 mb-2">
                                <i class="fa fa-file-invoice text-xs text-600"></i>
                                <span class="text-xs font-medium text-700">{{'POS.MEMBERSHIP_ADDON.BILLDETAILS' | translate}}</span>
                            </div>
                            @if ((planBreakUpCalculationResponse$ | async)?.plan_breakup_calculation; as billingBreakup) {
                              <!-- {{oJSON.stringify(billingBreakup)}} -->
                              @if (!applyDiscount) {
                                <div class="border-1 border-200 border-round text-sm surface-0 overflow-hidden">
                                    @for (charges of billingBreakup.charging_today.signup_charges; track charges.id) {
                                        <div
                                            class="px-3 py-2 flex align-items-center justify-content-between servicechargecontainer"
                                            [attr.data-testid]="'signup-charge-'+charges.name_primary_language"
                                            [attr.aria-label]="'signup-charge-'+charges.name_primary_language"
                                        >
                                            <span>{{charges.name_primary_language}}</span>
                                            <span>
                                                {{ getChargeNetCost(charges) | currencyformat}}
                                            </span>
                                        </div>
                                        @if (!isInclusive && charges.tax && charges.tax.length > 0) {
                                            @for (taxItem of charges.tax; track taxItem.id) {
                                                <div class="px-3 py-1 flex align-items-center justify-content-between text-xs text-400 border-top-1 border-dashed border-100"
                                                    [attr.aria-label]="'charge-tax-'+charges.name_primary_language+'-'+taxItem.type"
                                                    [attr.data-testid]="'charge-tax-'+charges.name_primary_language+'-'+taxItem.type">
                                                    <span class="pl-3">└ {{ taxItem.type }} ({{ taxItem.rate }}%)</span>
                                                    <span>{{ taxItem.amt_in_minor_currency | currencyformat }}</span>
                                                </div>
                                            }
                                        }
                                    }
                                    <!-- Charges + Service Tax Subtotal -->
                                    @if (!isInclusive) {
                                        @let chargeTaxTotal = getTotalTaxAmount(billingBreakup.charging_today.service_first_charge?.services || []) +
                                            getTotalTaxAmount(billingBreakup.charging_today.service_non_recurring?.services || []) +
                                            getTotalChargeTaxAmount(billingBreakup.charging_today.signup_charges);
                                        @if (chargeTaxTotal > 0) {
                                            <div class="px-3 py-2 flex align-items-center justify-content-between bg-orange-50 border-top-1 border-200"
                                                aria-label="charges-tax-total"
                                                data-testid="charges-tax-total">
                                                <span class="text-xs font-medium text-orange-700">
                                                    <i class="fa fa-receipt text-xs mr-1"></i>
                                                    {{'POS.MEMBERSHIP_ADDON.TAXES' | translate}} ({{'RETAIL_PRODUCTS.CHARGES' | translate}})
                                                </span>
                                                <span class="text-xs font-medium text-orange-700">{{ chargeTaxTotal | currencyformat }}</span>
                                            </div>
                                        }
                                    }
                                    <!-- <ng-container *ngFor="let product of billingBreakup.charging_today.products; trackBy: trackByProductId">
                                        <div class="px-3 py-2 flex align-items-center justify-content-between servicechargecontainer">
                                            <span *ngIf="getProductSkuDetails(product.sku_id) as productSku">{{ productSku?.sku_name_primary_language || product.sku_name_primary_language}}</span>
                                            <span>{{ (product?.taxable_cost_in_minor_currency * product.quantity) | currencyformat }}</span>
                                        </div>
                                    </ng-container> -->

                                    <!-- Products Section -->
                                    @if (billingBreakup.charging_today.products && billingBreakup.charging_today.products.length > 0) {
                                        <!-- Products Header -->
                                        <div class="px-3 py-2 flex align-items-center gap-2 bg-blue-50 border-round">
                                            <i class="fa fa-cube text-blue-600 text-xs"></i>
                                            <span class="text-xs font-medium text-blue-900">
                                                {{ 'RETAIL_PRODUCTS.PRODUCTS' | translate }} ({{ billingBreakup.charging_today.products.length }})
                                            </span>
                                        </div>

                                        <!-- Products List -->
                                        <div class="products-container">
                                            @for (product of billingBreakup.charging_today.products; track trackByProductId($index, product)) {
                                              <div class="px-3 py-2 flex align-items-center justify-content-between servicechargecontainer">
                                                  <!-- Product Info -->
                                                  <div class="flex align-items-center gap-2 flex-1">
                                                      <div class="w-1-5rem h-1-5rem bg-blue-100 border-round flex align-items-center justify-content-center flex-shrink-0">
                                                          <i class="fa fa-box text-blue-600 text-xs"></i>
                                                      </div>
                                                      @if (getProductSKuDetails(product.sku_id); as productSku) {
                                                        <div class="flex-1">
                                                        <div class="text-sm font-medium text-900 mb-1 line-height-2">
                                                            {{ productSku?.sku_name_primary_language || product.sku_name_primary_language }}
                                                        </div>
                                                        <div class="flex align-items-center gap-2">
                                                            <span class="text-xs px-1 py-0 bg-surface-100 border-round text-600">
                                                                {{ productSku?.sku_code || 'N/A' }}
                                                            </span>
                                                            <span class="text-xs text-blue-800 font-medium">
                                                                Qty: {{ product.quantity }}
                                                            </span>
                                                        </div>
                                                        </div>
                                                      }
                                                  </div>

                                                  <!-- Product Price (taxable subtotal; line total incl. tax when applicable) -->
                                                  <div class="text-right flex-shrink-0">
                                                      <div class="text-sm font-bold text-900">
                                                          @if (!isInclusive && getTaxAmount(product.tax) > 0) {
                                                            {{ getProductLineTotal(product) | currencyformat }}
                                                          } @else {
                                                            {{ product.taxable_cost_in_minor_currency | currencyformat }}
                                                          }
                                                      </div>
                                                      <div class="text-xs text-600">
                                                          {{ (product.taxable_cost_in_minor_currency / product.quantity) | currencyformat }} × {{ product.quantity }}
                                                          @if (getTaxAmount(product.tax) > 0) {
                                                            <span class="text-500"> + {{ getTaxAmount(product.tax) | currencyformat }} {{ 'POS.MEMBERSHIP_ADDON.TAXES' | translate }}</span>
                                                          }
                                                      </div>
                                                  </div>
                                              </div>
                                              @if (product.tax && product.tax.length > 0 && getTaxAmount(product.tax) > 0) {
                                                  @for (taxItem of product.tax; track taxItem.id) {
                                                      <div class="px-3 py-1 flex align-items-center justify-content-between text-xs text-400 border-top-1 border-dashed border-100"
                                                          [attr.aria-label]="'product-tax-'+product.sku_id+'-'+taxItem.type"
                                                          [attr.data-testid]="'product-tax-'+product.sku_id+'-'+taxItem.type">
                                                          <span class="pl-3">└ {{ taxItem.type }} ({{ taxItem.rate }}%)</span>
                                                          <span>{{ taxItem.amt_in_minor_currency | currencyformat }}</span>
                                                      </div>
                                                  }
                                              }
                                            }
                                        </div>
                                        <!-- Products Tax Subtotal -->
                                        @if (getTotalProductTaxAmount(billingBreakup.charging_today.products) > 0) {
                                            <div class="px-3 py-2 flex align-items-center justify-content-between bg-blue-50 border-top-1 border-200"
                                                aria-label="products-tax-total"
                                                data-testid="products-tax-total">
                                                <span class="text-xs font-medium text-blue-700">
                                                    <i class="fa fa-cube text-xs mr-1"></i>
                                                    {{'POS.MEMBERSHIP_ADDON.TAXES' | translate}} ({{'RETAIL_PRODUCTS.PRODUCTS' | translate}})
                                                </span>
                                                <span class="text-xs font-medium text-blue-700">{{ getTotalProductTaxAmount(billingBreakup.charging_today.products) | currencyformat }}</span>
                                            </div>
                                        }
                                    }
                                    
                                    @if (!discountApplied && !isCartFlow()) {
                                      <div class="px-3 py-2">
                                        <p-button (click)="ApplyDiscount(true)"
                                            label="{{'POS.MEMBERSHIP_ADDON.APPLY_DISCOUNT' | translate}}"
                                            icon="fa fa-percentage"
                                            styleClass="p-button-sm p-button-outlined w-full"
                                            [attr.aria-label]="'apply-discount-button'"
                                         />
                                      </div>
                                    }
                                    @if (discountApplied) {
                                      <div class="px-3 py-2 flex gap-2">
                                        <p-button (click)="ApplyDiscount(true)"
                                            label="{{'POS.MEMBERSHIP_ADDON.EDIT_DISCOUNT' | translate}}"
                                            icon="fa fa-edit"
                                            styleClass="p-button-sm p-button-outlined flex-1"
                                            [attr.aria-label]="'edit-discount-button'"
                                         />
                                        <p-button (click)="discountApplied=false;RemoveDiscount()"
                                            icon="fa fa-times"
                                            label="{{'POS.MEMBERSHIP_ADDON.REMOVE_DISCOUNT' | translate}}"
                                            styleClass="text-xs p-button-text -mr-3"
                                            [attr.aria-label]="'remove-discount-button'"
                                            [attr.data-testid]="'remove-discount-button'"
                                         />
                                      </div>
                                    }
                                    <div class="px-3 py-2 flex align-items-center justify-content-between bg-primary text-white">
                                        <span class="font-medium">{{'POS.MEMBERSHIP_ADDON.GRAND_TOTAL' | translate}}</span>
                                        @if (totalOneTimeCost$ | async; as totalOneTimeCost) {
                                          <span class="text-lg font-bold">
                                              {{totalOneTimeCost | currencyformat}}
                                          </span>
                                        }
                                    </div>
                                  </div>
                                } @else {
                                  <!-- Discount Area -->
                                  <div>
                                    <div [formGroup]="fgProducts">
                                        <div class="border-1 border-300 border-round text-sm surface-0">
                                            <div class="px-3 py-2 flex align-items-center justify-content-between">
                                                <strong class="flex align-items-center">{{'POS.MEMBERSHIP_ADDON.ONE_TIME_DISCOUNT'| translate}} </strong>
                                            </div>
                                            <!-- <div *ngFor="let controls of charges.controls; let n=index"> -->
                                            @for (charges of (planBreakUpCalculation$ | async)?.charging_today?.signup_charges; track charges.id; let n = $index) {
                                              <div formArrayName="charges" class="servicechargecontainer_edit">
                                                <div
                                                    [formGroupName]="0"
                                                    class="px-3 py-2 flex align-items-center justify-content-between"
                                                    [attr.data-testid]="'charge-discount-header-'+charges.name_primary_language"
                                                    [attr.aria-label]="'charge-discount-header-'+charges.name_primary_language"
                                                >
                                                    <span>{{charges.name_primary_language}}</span>
                                                    <div class="flex align-items-center">
                                                        <span>{{charges.amount_in_minor_currency | currencyformat}}</span>
                                                        <p-inputNumber [minFractionDigits]="2"
                                                            [maxFractionDigits]="4"
                                                            [formControlName]='"charges_"+charges.id'
                                                            styleClass="w-4rem h-2rem mx-2 text-sm ng-invalid ng-dirty"
                                                            inputStyleClass="px-1"
                                                            (onBlur)="calculateChargeDiscount(charges.amount_in_minor_currency,'charges_'+charges.id, 'discount_'+charges.id)"
                                                            [attr.aria-label]="'charge-amount-input-'+charges.name_primary_language"
                                                            [attr.data-testid]="'charge-amount-input-'+charges.name_primary_language"
                                                         />
                                                        <div class="p-inputgroup">
                                                            <span class="p-inputgroup-addon">%</span>
                                                            <p-inputNumber [formControlName]='"discount_"+charges.id'
                                                                [minFractionDigits]="2"
                                                                [maxFractionDigits]="4"
                                                                mode="decimal"
                                                                styleClass="w-3rem -ml-1 px-0 text-sm"
                                                                inputStyleClass="px-1"
                                                                (onBlur)="calculateChargeAmount(charges.amount_in_minor_currency,'charges_'+charges.id, 'discount_'+charges.id)"
                                                                [attr.aria-label]="'charge-discount-input-'+charges.name_primary_language"
                                                                [attr.data-testid]="'charge-discount-input-'+charges.name_primary_language"
                                                             />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            }

                                            <!-- Products Discount Section -->
                                            @for (product of (planBreakUpCalculation$ | async)?.charging_today?.products; track product.sku_id; let n = $index) {
                                              <div formArrayName="products" class="servicechargecontainer_edit">
                                                @if (getProductControls('product_'+product.sku_id)) {
                                                  <div
                                                      [formGroupName]="0"
                                                      class="px-3 py-2 flex align-items-center justify-content-between"
                                                      [attr.data-testid]="'product-discount-'+product.sku_id"
                                                      [attr.aria-label]="'product-discount-'+product.sku_id"
                                                  >
                                                      @if (getProductSKuDetails(product.sku_id); as productSku) {
                                                        <div class="flex align-items-center gap-2">
                                                            <span class="font-medium">{{ productSku.sku_name_primary_language }}</span>
                                                            <span class="text-xs px-1 py-0 bg-surface-100 border-round text-600">
                                                                Qty: {{ product.quantity }}
                                                            </span>
                                                        </div>
                                                      }
                                                    <div class="flex align-items-center">
                                                        <span>{{ product.base_cost_in_minor_currency | currencyformat }}</span>
                                                        <p-inputNumber [minFractionDigits]="2"
                                                            [maxFractionDigits]="4"
                                                            [formControlName]='"product_"+product.sku_id'
                                                            styleClass="w-4rem h-2rem mx-2 text-sm ng-invalid ng-dirty"
                                                            inputStyleClass="px-1"
                                                            (onBlur)="calculateProductDiscount(product.base_cost_in_minor_currency,'product_'+product.sku_id, 'productdiscount_'+product.sku_id)"
                                                            [attr.aria-label]="'product-amount-input-'+product.sku_id"
                                                            [attr.data-testid]="'product-amount-input-'+product.sku_id"
                                                         />
                                                        <div class="p-inputgroup">
                                                            <span class="p-inputgroup-addon">%</span>
                                                            <p-inputNumber [formControlName]='"productdiscount_"+product.sku_id'
                                                                [minFractionDigits]="2"
                                                                [maxFractionDigits]="4"
                                                                mode="decimal"
                                                                styleClass="w-3rem -ml-1 px-0 text-sm"
                                                                inputStyleClass="px-1"
                                                                (onBlur)="calculateProductAmount(product.base_cost_in_minor_currency,'product_'+product.sku_id, 'productdiscount_'+product.sku_id)"
                                                                [attr.aria-label]="'product-discount-input-'+product.sku_id"
                                                                [attr.data-testid]="'product-discount-input-'+product.sku_id"
                                                             />
                                                        </div>
                                                    </div>
                                                  </div>
                                                }
                                              </div>
                                            }

                                            <div class="p-3 border-top-1 border-300">
                                                <label for="discount-reason-textarea" class="font-medium text-700 text-xs mb-2 block uppercase">{{'POS.MEMBERSHIP_ADDON.DISCOUNT_REASON' | translate}}</label>
                                                <textarea
                                                    pInputTextarea
                                                    formControlName="charges_reason"
                                                    class="w-full h-4rem"
                                                    placeholder=""
                                                    [attr.aria-label]="'discount-reason-textarea'"
                                                    [attr.data-testid]="'discount-reason-textarea'"
                                                ></textarea>
                                                @if (ChargesDiscountReason.touched && ChargesDiscountReason.invalid) {
                                                  <app-error-msg [errors]="ChargesDiscountReason.errors" [fieldLabel]="'POS.MEMBERSHIP_ADDON.DISCOUNT_REASON' | translate" />
                                                }
                                            </div>

                                            @if (inValidDiscount) {
                                              <div class="px-3 flex justify-content-end">
                                                  <p-message severity="error" icon="fa fa-exclamation-triangle" styleClass="-mt-3 -mb-2" aria-label="invalid-discount-message">
                                                      {{ 'POS.MEMBERSHIP_ADDON.YOUCANNOTAPPLY' | translate }} {{ userDiscountLimit }} % {{ 'POS.MEMBERSHIP_ADDON.DISCOUNT' | translate }}
                                                  </p-message>
                                              </div>
                                            }
                                        </div>
                                    </div>
                                    <div class="flex align-items-center justify-content-between mt-3">
                                        <button
                                            (click)="StaffDiscountCancel();"
                                            pButton
                                            type="button"
                                            label="{{'common.PLACEHOLDER.CANCEL' | translate}}"
                                            class="text-sm p-button-text"
                                            [attr.aria-label]="'cancel-discount-button'"
                                            [attr.data-testid]="'cancel-discount-button'"
                                        ></button>
                                        <button
                                            (click)="StaffDiscountBreakup()"
                                            pButton
                                            type="button"
                                            label="{{'common.PLACEHOLDER.APPLY' | translate}}"
                                            class="text-sm p-button-text"
                                            [attr.aria-label]="'apply-discount-button'"
                                            [attr.data-testid]="'apply-discount-button'"
                                        ></button>
                                    </div>
                                  </div>
                                }
                            }
                                <!-- Discount Area -->
                            @else {
                              <div class="border-1 border-200 border-round text-sm surface-0 p-3 text-center">
                                  <div class="text-600 mb-2">
                                      <i class="fa fa-shopping-cart text-lg mb-2"></i>
                                      <div class="text-xs">{{'POS.MEMBERSHIP_ADDON.PLEASE_SELECT_CHARGE' | translate}}</div>
                                  </div>
                              </div>
                            }
                        </div>
                        <!-- Bill Details -->

                        <!-- Details -->

                        <!-- Details -->
                    </div>
                    <!-- Bill Date and Owner Section -->
                    @if (!isCartFlow()) {
                      <div class="bg-surface-0 px-3 py-2 border-top-1 border-200 mt-1">
                        <div class="grid">
                            <div class="col-12 md:col-6 py-1">
                                <label for="bill-date-calendar" class="font-medium text-700 text-xs mb-1 block">
                                    <i class="fa fa-calendar text-xs mr-1"></i>
                                    {{'POS.MEMBERSHIP_ADDON.BILL_DATE' | translate}}
                                </label>
                                <p-datepicker [showIcon]="true"
                                    formControlName="billdate"
                                    [readonlyInput]="true"
                                    placeholder="{{'common.PLACEHOLDER.SELECT_DATE' | translate}}"
                                    inputStyleClass="text-sm h-2rem"
                                    styleClass="w-full"
                                    [maxDate]="maxStartDate"
                                    [minDate]="minStartDate"
                                    [attr.aria-label]="'bill-date-calendar'"
                                    [attr.data-testid]="'bill-date-calendar'"
                                 />
                            </div>

                            <div class="col-12 md:col-6 py-1">
                                <label for="bill-owner-selector" class="font-medium text-700 text-xs mb-1 block">
                                    <i class="fa fa-user text-xs mr-1"></i>
                                    {{'POS.MEMBERSHIP_ADDON.BILL_OWNER' | translate}}
                                </label>
                                <staff-selector [formGroup]="fg"
                                    [controlName]="billingOwner"
                                    [id]="_selectedstaff"
                                    [styleClass]="'w-full text-sm h-2rem'"
                                    [placeHolder]="'CreateEditStaff.SELECT_PLACEHOLDER' | translate"
                                    [filterstaff]="_filterStaff"
                                    [attr.aria-label]="'bill-owner-selector'"
                                    [attr.data-testid]="'bill-owner-selector'"
                                 />
                                @if (billingOwner.dirty && billingOwner.invalid) {
                                  <app-error-msg [errors]="billingOwner.errors" [fieldLabel]="'POS.MEMBERSHIP_ADDON.BILL_OWNER' | translate" />
                                }
                            </div>
                        </div>
                      </div>
                    }
                  </div>
                }
            </div>
            <!-- Content -->

            <!-- Bottom Action Section -->
            @if (hasbillingRights) {
              <div class="sticky bottom-0 right-0 w-full bg-white border-top-1 border-200 p-3 shadow-4 z-5">
                  <div class="relative">
                      <!-- Cart Flow Button -->
                      @if (isCartFlow()) {
                        <p-button
                        [loading]="isSubmitting"
                        styleClass="w-full h-3rem"
                        severity="primary"
                        (click)="AddToCart()"
                        [attr.aria-label]="'add-to-cart-button'"
                        [attr.data-testid]="'add-to-cart-button'"
                    >
                          <ng-template pTemplate="content">
                              <i class="fa fa-cart-plus text-lg"></i>
                              <span class="font-medium">{{'RETAIL_PRODUCTS.ADD_TO_CART' | translate}}</span>
                          </ng-template>
                        </p-button>
                      }

                      <!-- Payment Flow Button -->
                      @if (!isCartFlow()) {
                        <div class="flex flex-column gap-1">
                          <!-- Online Payment Button (Primary) -->

                          <p-button
                            [loading]="isSubmitting"
                            styleClass="w-full h-2-5rem text-sm hover:shadow-2 transition-all transition-duration-200"
                            severity="success"
                            (click)="OpenOnlinePayment()"
                            [attr.aria-label]="'continue-online-payment-button'"
                            [attr.data-testid]="'continue-online-payment-button'"
                          >
                            <ng-template pTemplate="content">
                              <i class="fa fa-credit-card text-lg" style="pointer-events: none;"></i>
                              <span class="font-medium" style="pointer-events: none;">{{'POS.MEMBERSHIP_ADDON.CONTINUE_ONLINE_PAYMENT' | translate}}</span>
                            </ng-template>
                          </p-button>
                        

                          <!-- Saved Payment Methods Button -->
                          @if (showPayViaSavedPaymentMethods) {
                            <p-button
                              [loading]="isSubmitting"
                              styleClass="w-full h-2-5rem text-sm hover:shadow-2 transition-all transition-duration-200"
                              severity="secondary"
                              (click)="OpenSavedPaymentMethods()"
                              [attr.aria-label]="'pay-with-saved-card-button'"
                              [attr.data-testid]="'pay-with-saved-card-button'"
                            >
                              <ng-template pTemplate="content">
                                <div class="flex align-items-center justify-content-center w-full" style="pointer-events: none;">
                                  <i class="fa fa-credit-card text-base mr-2"></i>
                                  <span class="font-medium">{{'POS.MEMBERSHIP_ADDON.PAY_WITH_SAVED_METHOD' | translate}}</span>
                                </div>
                              </ng-template>
                            </p-button>
                          }

                          <!-- POS Terminal Button -->
                          @if (showChargeOnPosTerminal && !isCartFlow()) {
                            <div class="border-bottom-1 border-200 pb-1">
                              <p-button
                                pRipple
                                (onClick)="PosDeviceCharge()"
                                [loading]="isSubmitting"
                                [disabled]="inValidDiscount || !fg.valid"
                                styleClass="w-full h-2-5rem text-sm"
                                severity="secondary"
                                [attr.aria-label]="'charge-on-pos-button'"
                                [attr.data-testid]="'charge-on-pos-button'">
                                <ng-template pTemplate="content">
                                  <img width="14" src="assets/img/icons/icon-terminal.svg" alt="POS Terminal" class="mr-2" style="pointer-events: none;" />
                                  <span style="pointer-events: none;">{{ 'POS_DEVICE.CHARGE_ON_POS' | translate }}</span>
                                </ng-template>
                              </p-button>
                            </div>
                          }

                          <!-- Offline Payment Button -->
                          <p-button
                            [loading]="isSubmitting"
                            styleClass="w-full h-2-5rem text-sm hover:shadow-2 transition-all transition-duration-200"
                            severity="secondary"
                            (click)="OpenOfflinePayment()"
                            [attr.aria-label]="'record-offline-payment-button'"
                            [attr.data-testid]="'record-offline-payment-button'"
                          >
                            <ng-template pTemplate="content">
                              <div class="flex align-items-center justify-content-center w-full" style="pointer-events: none;">
                                <i class="fa fa-money-bill-wave text-base mr-2"></i>
                                <span class="font-medium">{{'common.BUTTONS.RECORD_OFFLINE_PAYMENT_BTN' | translate}}</span>
                              </div>
                            </ng-template>
                          </p-button>
                        </div>
                      }
                  </div>
              </div>
            }
            <!-- Bottom Action Section -->
        </form>
    </ng-template>
</p-drawer>

<!-- Change Billing Name Modal  -->
<p-dialog [visible]="changeBillingName" [resizable]="false" appendTo="body" [modal]="true" [breakpoints]="{'767px': '100vw'}" [style]="{width: '500px'}" styleClass="no-header-modal">
    <ng-template pTemplate="header" styleClass="hidden" />
    <ng-template pTemplate="content" styleClass="p-0">
        <form [formGroup]="billingNameForm">
            <!-- Header -->
            <div class="p-3 flex align-items-center justify-content-between relative border-bottom-1 border-300">
                <h2 class="mb-0 text-sm">{{'POS.MEMBERSHIP_ADDON.CHANGE_BILLING_NAME' | translate}}</h2>
                <div class="fa fa-times text-xl text-600 cursor-pointer" (click)="changeBillingName = false"></div>
            </div>
            <!-- Header -->

            <!-- Modal Content -->
            <div class="surface-100 border-bottom-1 border-300 p-3">
                <!-- Column -->
                <label for="billing-name-input" class="font-medium text-700 text-xs mb-2 block uppercase"> {{'POS.MEMBERSHIP_ADDON.NEW_BILLING_NAME' | translate}}</label>
                <input type="text" class="text-sm w-full" formControlName="billing_name" pInputText placeholder="Enter the new billing name" [attr.aria-label]="'billing-name-input'" [attr.data-testid]="'billing-name-input'" />
                @if (billingNameFormControl.dirty && billingNameFormControl.invalid) {
                  <app-error-msg [errors]="billingNameFormControl.errors" [fieldLabel]="'POS.MEMBERSHIP_ADDON.NEW_BILLING_NAME' | translate" />
                }
                <!-- Column -->
            </div>
            <!-- Modal Content -->

            <!-- Modal Footer -->
            <div class="surface-0 border-top-1 border-300 p-3">
                <p-button [disabled]="billingNameFormControl.invalid"
                    styleClass="w-full text-lg"
                    label="{{'POS.MEMBERSHIP_ADDON.NEW_BILLING_NAME' | translate}}"
                    (click)="changeBillingName=false"
                    [attr.aria-label]="'save-billing-name-button'"
                    [attr.data-testid]="'save-billing-name-button'"
                 />
            </div>
            <!-- Modal Footer -->
        </form>
    </ng-template>
</p-dialog>
<!-- Change Billing Name Modal  -->

@if (otherPaymentsModal$ | async) {
  <other-payment [otherPaymentsModal]="otherPaymentsModal$ | async"
      [isCashRecurring]="true"
      [creditBalance]="clientCreditBalance"
      [showCreditBalance]="true"
      [tenantId]="billedAtTenantId()"
      [totalAmtTobePaid]="totalOneTimeCost$ | async"
      (hideOtherPaymentDialog)="HideOtherPaymentDialog($event)"
      (closeOtherPaymentDialog)="closeOtherPaymentDialog($event)"
   />
}

@if (showErrorPopup | async; as showPopup) {
  <app-errors [error]="error" [visible]="showPopup"  (onHide)="closeDialog()"  [errorData]="errorMessages" (hideErrorPopup)="HideErrorPopup($event)" />
}

<!-- Product Fulfillment Popup -->
<product-fulfillment-popup [visible]="showProductFulfillmentPopup"
    [products]="productFulfillmentItems"
    (confirmFulfillment)="onProductFulfillmentConfirm($event)"
    (cancelFulfillment)="onProductFulfillmentCancel()" />

<!-- Saved Payment Methods Popup -->
@if (showSavedPaymentMethodsPopup.value) {
  <saved-payment-methods-popup [visible]="showSavedPaymentMethodsPopup.value"
    [clientId]="clientId"
    [tenantId]="billedAtTenantId()"
    [currencyCode]="countryCode"
    (paymentMethodSelected)="onSavedPaymentMethodSelected($event)"
    (hideDialog)="onSavedPaymentMethodsPopupClosed()" />
}

@if (showDeviceList) {
  <pos-device-list
    [visible]="showDeviceList"
    [loadReady]="posGatewaysLoaded"
    [tenantId]="tenantId"
    [activeOnly]="true"
    [autoSelectSingle]="true"
    (closeDevicesPopup)="closeDevicesPopup($event)" />
}

@if (paymentFailed) {
  <p-dialog [visible]="paymentFailed" [resizable]="false" appendTo="body" [modal]="true"
    [breakpoints]="{'767px': '100vw'}" [style]="{width: '550px'}" styleClass="no-header-modal overflow-visible">
    <ng-template pTemplate="header" styleClass="hidden" />
    <div class="p-3 align-items-center justify-content-between border-bottom-1 border-300 text-right">
      <i class="fa fa-times text-xl text-600 cursor-pointer" (click)="closePaymentFailed()" [attr.aria-label]="'close-payment-failed-dialog'"></i>
    </div>
    <ng-template pTemplate="content" styleClass="p-0">
      <div class="p-5 text-center">
        <i class="fa fa-times-circle p-error text-8xl"></i>
        <h5 class="text-lg p-error mb-3 mt-5">{{ 'POS_DEVICE.PAYMENT_FAILED' | translate }}</h5>
        @if (paymentFailedMessages.length > 0) {
          @for (message of paymentFailedMessages; track message) {
            <p class="mb-5">{{ message }}</p>
          }
        } @else {
          <p class="mb-5">{{ 'POS_DEVICE.FAILED_REASON' | translate }}</p>
        }
        <p-button [label]="'POS_DEVICE.RETRY_PAYMENT' | translate" (click)="RetryPayment()" styleClass="text-sm w-12rem" [attr.aria-label]="'retry-payment-button'" [attr.data-testid]="'retry-payment-button'" />
      </div>
    </ng-template>
  </p-dialog>
}

@if (transactionInProcess) {
  <p-dialog [visible]="transactionInProcess" [resizable]="false" appendTo="body" [modal]="true"
    [closeOnEscape]="false" [dismissableMask]="false" [blockScroll]="true" [closable]="false" [baseZIndex]="12000"
    [breakpoints]="{'767px': '100vw'}" [style]="{width: '550px'}" styleClass="no-header-modal overflow-visible">
    <ng-template pTemplate="header" styleClass="hidden" />
    <ng-template pTemplate="content" styleClass="p-0">
      <div class="p-5 text-center">
        <p-progressSpinner styleClass="w-8rem h-8rem" strokeWidth="4" animationDuration=".5s" />
        <h5 class="text-lg p-error mb-3 mt-5">{{ 'POS_DEVICE.TRANSACTION_PROGRESS' | translate }}</h5>
        <p class="mb-5">{{ 'POS_DEVICE.DO_NOT_CLOSE' | translate }}</p>
      </div>
    </ng-template>
  </p-dialog>
}

@if (paymentConfirmationPending) {
  <p-dialog [visible]="paymentConfirmationPending" [resizable]="false" appendTo="body" [modal]="true"
    [closeOnEscape]="paymentConfirmationTimedOut" [dismissableMask]="false" [blockScroll]="true" [baseZIndex]="12000"
    [breakpoints]="{'767px': '100vw'}" [style]="{width: '550px'}" styleClass="no-header-modal overflow-visible"
    [closable]="false">
    @if (paymentConfirmationTimedOut) {
      <div class="p-3 align-items-center justify-content-end border-bottom-1 border-300 text-right">
        <button type="button" class="border-none bg-transparent p-0 cursor-pointer"
          (click)="closePaymentConfirmationTimeout()"
          [attr.aria-label]="'close-payment-confirmation-timeout-dialog'"
          [attr.data-testid]="'close-payment-confirmation-timeout-dialog'">
          <i class="fa fa-times text-xl text-600"></i>
        </button>
      </div>
    } @else {
      <ng-template pTemplate="header" styleClass="hidden" />
    }
    <ng-template pTemplate="content" styleClass="p-0">
      <div class="p-5 text-center" data-testid="payment-confirmation-dialog">
        @if (paymentConfirmationTimedOut) {
          <i class="fa fa-clock-o text-orange-500 text-8xl"></i>
          <h5 class="text-lg text-orange-500 mb-3 mt-5">{{ paymentConfirmationTimeoutMessage }}</h5>
        } @else {
          <p-progressSpinner styleClass="w-8rem h-8rem" strokeWidth="4" animationDuration=".5s" />
          <h5 class="text-lg mb-3 mt-5">{{ 'POS_DEVICE.CONFIRMING_PAYMENT_STATUS' | translate }}</h5>
          @if (paymentConfirmationShowTimeLimit) {
            <p class="mb-2 font-semibold text-primary" data-testid="payment-confirmation-countdown">
              {{ 'POS_DEVICE.PAYMENT_TIME_REMAINING' | translate: { time: paymentConfirmationCountdownDisplay } }}
            </p>
            <p class="mb-3 text-sm text-600">{{ 'POS_DEVICE.PAYMENT_TIME_LIMIT_INFO' | translate }}</p>
          }
          <p class="mb-5">{{ 'POS_DEVICE.DO_NOT_CLOSE' | translate }}</p>
        }
      </div>
    </ng-template>
  </p-dialog>
}